import React, { useMemo, useState } from 'react';
import { getUrl, ROUTES } from '../../network/url';
import KBFetch from '../../api';

function isTenDigitPhone(value: string): boolean {
  return /^\d{10}$/.test(value.trim());
}

export const useRevokeBureauConsentActions = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [consentChecked, setConsentChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);

  const canSubmit = useMemo(() => {
    const trimmedName = name.trim();
    return trimmedName.length > 0 && isTenDigitPhone(phone) && consentChecked;
  }, [name, phone, consentChecked]);

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setName('');
    setPhone('');
    setConsentChecked(false);
    setSubmitError(null);
    setSubmitting(false);
  };

  const handleSubmit = async () => {
    if (!canSubmit || submitting) return;
    setSubmitError(null);
    setSubmitting(true);
    const method = 'POST';
    const contentType = 'application/json';
    const body = JSON.stringify({
      userName: name,
      mobileNumber: phone
    });
    const url = getUrl(ROUTES.REVOKE_USER_CONSENT);
    try {
      const result = await KBFetch(ROUTES.REVOKE_USER_CONSENT, url, {
        method,
        headers: {
          'content-type': contentType
        },
        body
      });
      setSubmitting(false);
      if (!result || !(result as Response).ok) {
        setSubmitError(
          'We could not record your request. Please try again in a few minutes.'
        );
        return;
      }
      handleCloseDialog();
      setSuccessDialogOpen(true);
    } catch {
      setSubmitting(false);
      setSubmitError(
        'Something went wrong while sending your request. Please try again.'
      );
    }
  };

  const handleCloseSuccessDialog = () => {
    setSuccessDialogOpen(false);
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
    setPhone(digits);
  };

  return {
    submitError,
    dialogOpen,
    successDialogOpen,
    submitting,
    name,
    phone,
    consentChecked,
    canSubmit,
    handleCloseDialog,
    handleCloseSuccessDialog,
    setName,
    handlePhoneChange,
    setSubmitError,
    setDialogOpen,
    setConsentChecked,
    handleSubmit
  };
};
